import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor, StyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface BarProps {
	percentage: number;
	isError: boolean;
}

interface LabelProps {
	isError?: boolean;
}

interface ButtonCancelProps {
	isError: boolean;
}

const Wrapper = styled('div')`
	margin-bottom: 20px;
`;

const LabelWrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;

const ProgressLabel = styled('div')`
	font-family: HelveticaNeue, sans-serif;
	font-size: 37px;
	line-height: 50px;
	letter-spacing: 1.65px;
	color: ${hexToRgba(StyleColor.Black, 30)};
`;

const Label = styled(Translate)`
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${(props: LabelProps) => props.isError ? NewStyleColor.Red300 : NewStyleColor.Black};
`;

const ButtonCancel = styled('button')`
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	margin-left: 20px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background-color: ${(props: ButtonCancelProps) => props.isError ? NewStyleColor.Red300 : StyleColor.Grey200};
	outline: 0;
	cursor: pointer;

	svg {
		width: 12px;
		height: 12px;
		fill: ${(props: ButtonCancelProps) => props.isError ? StyleColor.White : StyleColor.Grey450};
	}
`;

const Bar = styled('div')`
	position: relative;
	height: 3px;
	border-radius: 1px;
	background-color: ${StyleColor.White};

	&::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: ${(props: BarProps) => `${props.percentage}%`};
		border-radius: inherit;
		background-image: ${(props: BarProps) => `linear-gradient(to right, ${props.isError
			? `${NewStyleColor.Red400} 24%, ${NewStyleColor.Red200} 78%`
			: `${NewStyleColor.Blue400} 56%, ${NewStyleColor.Blue300} 92%`})`};
	}
`;

export {
	Wrapper,
	LabelWrapper,
	ProgressLabel,
	Label,
	ButtonCancel,
	Bar,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/ProgressBar/styles.ts